const getReCAPTCHAKey = () => {
    const hostname = document.location.hostname;

    if (process.env.NODE_ENV === 'development') {
      return process.env.REACT_APP_RECAPTCHA_SITE_KEY_DV;
    }
  
    if (hostname.includes('azoomee')) {
      return process.env.REACT_APP_RECAPTCHA_SITE_KEY_AZ;
    }
  
    if (hostname.includes('dvmkids') || hostname.includes('davinci')) {
      return process.env.REACT_APP_RECAPTCHA_SITE_KEY_DV;
    }
  };
  
  
  
  export default getReCAPTCHAKey